module.exports = __webpack_public_path__ + "img/image.22a8097.svg";